module.exports = __webpack_public_path__ + "static/media/Lightning.a8987802.svg";